<template>
  <div>
    <div class="d-flex flex-column" v-if="isShowCardList">
      <div class="d-flex justify-content-between">
        <h4 class="py-4 text">
          <span v-if="isPastor">Cards remaining on your account: {{ remainingCards }}</span>
        </h4>
        <a-button size="large" type="primary" class="text-center align-self-end p-3" ghost @click="doAddNewCard">NEW CARD ORDER</a-button>
      </div>
      <h3>Church Invitation Cards</h3>
      <p>Order cards for your church, youth group, or special events</p>

      <div class="d-flex flex-column">
        <card-item v-for="item in cardItems" :key="item.id" :data="item" :cards-sources="dataSources" @onOpenImage="doOpenImage" @onAction="doAction" />
      </div>
    </div>
    <a-button v-else type="primary" class="text-center p-2 mr-4 mb-2" ghost @click="doAction([])">Back to card orders</a-button>
    <Review v-if="isShowReview" :card-url="cardUrl" :data="cardSelected" @onSuccess="doUpdate" @onOpenImage="doOpenImage" />
    <re-order v-if="isReOrder" :card-url="cardUrl" :data="cardSelected" @onSuccess="doUpdate" @onOpenImage="doOpenImage" @onStartOver="doAddNewCard" />
  </div>
</template>
<script>
import CardItem from './cardItem';
import Review from './review';
import ReOrder from './reorder';
import { empty } from '@/utils';
export default {
  components: {
    CardItem,
    Review,
    ReOrder,
  },
  props: {
    cardItems: {
      type: Array,
      required: true,
    },
    dataSources: {
      type: Object,
    },
  },
  data: () => ({
    isShowCardList: true,
    isShowReview: false,
    isReOrder: false,
    cardUrl: {},
    cardSelected: {},
  }),
  computed: {
    remainingCards() {
      const membership = this.$store.state.user.user.membership;
      return membership ? membership.active_cards : 0;
    },
  },
  methods: {
    doAddNewCard() {
      this.$emit('onAddNewCard');
    },
    doUpdate() {
      this.$emit('onUpdated');
      this.doAction([]);
    },
    doAction([type, card, cardUrl]) {
      this.isShowCardList = false;
      this.isShowReview = false;
      this.isReOrder = false;
      if (!empty(type)) {
        this.cardUrl = cardUrl;
        this.cardSelected = card;
        switch (type) {
          case 'review':
            this.isShowReview = true;
            break;
          case 're-order':
            this.isReOrder = true;
            break;
        }
      } else {
        this.isShowCardList = true;
      }
    },
    doOpenImage(image) {
      this.$emit('onImgSource', image);
    },
  },
};
</script>
<style lang="scss" scoped>
h3 {
  color: rgba(0, 0, 0, 0.65);
}
</style>
<style lang="scss">
img {
  border-radius: 6px;
}
</style>
